// Per client's "HOW IT WORKS" 5-step flow. Step 3 ("Pay Securely") is
// worded around the ₹499 consultation payment rather than a full
// service payment, since that's the only payment a visitor makes
// upfront now — see lib/bookingFlags.ts for why full-service pricing
// isn't collected online anymore.
const STEPS = [
  { number: '01', title: 'Select Your Service', desc: 'Browse our services and pick the one that fits your need.' },
  { number: '02', title: 'Book a Consultation', desc: 'Pay ₹499 to book a 30-minute call and discuss your requirement.' },
  { number: '03', title: 'Get Your Quotation', desc: 'We understand your case and share a clear, personalized quotation.' },
  { number: '04', title: 'Submit Documents', desc: 'Once you proceed, share the required documents securely.' },
  { number: '05', title: 'Receive Certificate/Documents', desc: 'Our experts process your application and deliver the result.' },
];

export function ProcessFlow() {
  return (
    <section className="bg-paper py-16">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="text-center">
          <p className="font-mono text-xs uppercase tracking-widest text-ledger-green">How it works</p>
          <h2 className="mt-2 font-display text-3xl font-bold text-ink">From Consultation to Completion</h2>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-5">
          {STEPS.map((step, i) => (
            <div key={step.number} className="relative">
              <span className="font-display text-5xl font-bold text-seal-blue/15">{step.number}</span>
              <h3 className="mt-2 font-display text-lg font-semibold text-ink">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink/60">{step.desc}</p>
              {i < STEPS.length - 1 && (
                <div className="absolute right-[-1rem] top-6 hidden text-ink/20 lg:block">→</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
